import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class PrintViewerService {


  htmlContent: string ;


  setHtmlContent(content: string) {
    console.log('[PrintViewerService] setHtmlContent called');
   // this.htmlContent = content;
   this.htmlContent = "<html><body>test</body></html>";
  }

  getHtml() : string {
    return this.htmlContent;
  }

  clearHtml() {
    this.htmlContent = "";
  }
}